import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { IBusinessExemptInspectionsViewModel, IResponseLettersView } from 'app/models/mainMenu/mainMenu';
import { BusinessService } from 'app/services/business/business.service';
import { ComplaintService } from 'app/services/complaint/complaint.service';
import { MainMenuService } from 'app/services/mainMenu/mainMenu.service';

@Component({
  selector: 'app-mainMenu-annualInspections',
  templateUrl: './annualInspections.component.html',
  styleUrls: ['./annualInspections.component.scss']
})

export class AnnualInspectionsComponent implements OnInit {
  @Input() countyId: string = '';
  annualInspectionsList: IBusinessExemptInspectionsViewModel[] = [];

  displayedColumns: string[] = ['businessName', 'businessAddress', 'businessCity', 'businessZip'];
  dataSource = new MatTableDataSource<IBusinessExemptInspectionsViewModel>(this.annualInspectionsList);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public mainMenu: MainMenuService,
    public businessService: BusinessService,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    // Annual Inspections
    this.mainMenu.getExemptInspections(this.countyId).subscribe({
      next: response => {
        this.mainMenu.annualInspectionsList = response;
        this.dataSource.data = this.mainMenu.annualInspectionsList;
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Annual Inspections");
      },
    });
  }

  rowClick(row: any) {
  }

  gotoBusiness(businessId: string) {
    this.businessService.businessId = +businessId;
    this.businessService.businessTab = 6;
    this.sharedService.doRedirect('business/business');
  }
}
